import { createFileRoute } from '@tanstack/react-router'

import { DeclineRetriesScreen } from './-components/decline-retries-screen.tsx'

export const Route = createFileRoute('/risk/decline-retries')({
  component: DeclineRetriesScreen
})
